import { ApexOptions } from 'apexcharts';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  LineCharContainer,
  LineChartFilters,
  LineChartHeader,
  LineChartInfo,
} from './styles';
import Heading from '../../shared/Heading';
import { AiFillInfoCircle } from 'react-icons/ai';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { LineChartProps } from './LineChartInterfaces';
import { useFilters } from '../../../../context/filters';

export function LineChart({
  title,
  total,
  series,
  categories,
  type = 'line',
  stroke = 'straight',
  seeMore,
  selectOptions,
  selectLabel = 'Filtros',
  filterLabel,
}: Readonly<LineChartProps>) {
  const {
    setDashAcessosFilter,
    setDashRegistroSasFilter,
    setDashAtendSseFilter,
    setDashUsuariosFilter,
    dashAcessosFilter,
    dashRegistroSasFilter,
    dashAtendSseFilter,
    dashUsuariosFilter,
  } = useFilters();

  const handleContextFilterChange = (
    type: string | undefined,
    value: string
  ) => {
    if (type === 'acessos') {
      setDashAcessosFilter(value);
    } else if (type === 'sas') {
      setDashRegistroSasFilter(value);
    } else if (type === 'sse') {
      setDashAtendSseFilter(value);
    } else if (type === 'usuarios') {
      setDashUsuariosFilter(value);
    }
  };

  const handleFilterChange = (event: SelectChangeEvent) => {
    const value: string = event.target.value;

    handleContextFilterChange(filterLabel, value);
  };

  const options: ApexOptions = {
    chart: {
      toolbar: {
        show: false,
      },
      height: 180,
      type: type,
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3, 3, 3],
      curve: stroke,
      // dashArray: [0, 8, 5],
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          ' - ' +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          ''
        );
      },
      horizontalAlign: 'left',
      showForNullSeries: false,
      fontSize: '12px',
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: categories?.categories,
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
      ],
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    colors: ['var(--blue-100)', 'var(--green-200)', 'var(--pink-200)'],
  };

  return (
    <LineCharContainer>
      <LineChartHeader>
        <LineChartInfo>
          <div className="heading-line">
            <Heading as="h3" size="medium" color="gray">
              Total de {title}
            </Heading>
            <AiFillInfoCircle color="var(--gray)" />
          </div>
          <Heading as="h1" size="large" color="blue">
            {total?.toLocaleString()}
          </Heading>
        </LineChartInfo>

        {selectOptions && (
          <LineChartFilters>
            <FormControl fullWidth size="small">
              <InputLabel id="select-label">{selectLabel}</InputLabel>
              <Select
                labelId="select-label"
                id="select-filter"
                value={
                  filterLabel === 'acessos'
                    ? dashAcessosFilter
                    : filterLabel === 'sas'
                    ? dashRegistroSasFilter
                    : filterLabel === 'usuarios'
                    ? dashUsuariosFilter
                    : dashAtendSseFilter
                }
                label="Filtros2"
                onChange={handleFilterChange}
              >
                {selectOptions?.map(({ label, value }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </LineChartFilters>
        )}
      </LineChartHeader>
      <ReactApexChart
        options={options}
        series={series}
        type={type}
        height={180}
      />
      {seeMore && (
        <Button
          onClick={seeMore}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ marginBottom: '1rem' }}
        >
          Ver mais
        </Button>
      )}
    </LineCharContainer>
  );
}
